import type { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';

import { BASE } from '@/types/utils/sizesType';

import { DefaultAvatar as Avatar } from '@/components/base/Avatar';

const GroupCell = ({ group }: { group: SpGroupType }) => {
    return (
        <Avatar
            radius="rounded-md"
            fallback={group.name.substring(0, 2)}
            url={group.image}
            customColorClass={group.fallback_style}
            size={BASE}
        />
    );
};

export default GroupCell;
